module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="quick-view">\n    <div class="templates"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experienceOverview/QuickViewAddExperienceView.tpl
// module id = 2888
// module chunks = 0